export type AgentUiContextKey = string & {
	readonly __agentUiContextKey: unique symbol;
};

export function defineAgentUiContextKey(key: string): AgentUiContextKey {
	return key as AgentUiContextKey;
}

export function pageAgentUiContextKey(pageKey: string): AgentUiContextKey {
	return defineAgentUiContextKey(`page.${pageKey}`);
}
